// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ScheduledReportFrequencySchema = z.enum(['WEEKLY','MONTHLY','QUARTERLY','SEMI_ANNUAL','YEARLY'] as const);

export type ScheduledReportFrequencyType = `${z.infer<typeof ScheduledReportFrequencySchema>}`

export default ScheduledReportFrequencySchema;
